import { FC } from 'react';

import ContentGrid from '../notes/ContentGrid';

import P2PAdminHeader from './P2PAdminHeader';
import classes from './P2PAdminPanel.module.css';
import { P2PProvider } from './P2PContext';
import P2PSidebar from './P2PSidebar';
import P2PUserDetails from './P2PUserDetails';
import P2PUsersList from './P2PUsersList';

const P2PAdminPanel: FC<{ target: string | undefined }> = ({target}) => {
    return (
        <P2PProvider target={target}>
            <section className={classes['section']}>
                <P2PAdminHeader />
                <ContentGrid
                    style={{
                        gridTemplateColumns: '190px 330px auto',
                        gridTemplateRows: 'calc(100% - 60px)',
                    }}>
                    <P2PSidebar />
                    <P2PUsersList />
                    <P2PUserDetails />
                </ContentGrid>
            </section>
        </P2PProvider>
    );
};

export default P2PAdminPanel;
